import './About.scss';
import ContactUs from '../ContactUs';
import AboutDetails from './AboutDetails';
import PrivacyPolicy from './PrivacyPolicy';
import React, { Component, Fragment } from 'react';
import { SettingOptions, SettingsHeader } from '../Settings';
import PropTypes from 'prop-types';
export default class About extends Component {
    constructor(props) {
        super(props)
        this.state = {
            parentAboutStatus: true,
            activeTab: null,
        };
    }

    backToAbout = () => {
        this.setState({
            parentAboutStatus: true,
            activeTab: null
        });
    }

    handleAbout = (label) => {
        this.setState({
            parentAboutStatus: false,
            activeTab: label
        });
    }

    handleContactUs = (label) => {
        this.setState({
            parentAboutStatus: true,
            activeTab: label
        });
    }

    handlePopupClose = () => {
        this.setState({
            parentAboutStatus: true,
            activeTab: null
        });
    }


    render() {
        let { parentAboutStatus, activeTab } = this.state
        const { handleBackToSetting } = this.props
        const openLink = (url) => {
            window.open(url, "_blank", "noopener,noreferrer");
        };
        return (
            <Fragment>
                {parentAboutStatus &&
                    <div className="setting-container">
                        <div>
                            <div className="settinglist">
                                <SettingsHeader
                                    handleBackFromSetting={handleBackToSetting}
                                    label={'Terms & Policies'}
                                />
                                <ul className="setting-list-ul About">
                                    {/* About Us */}
                                    <SettingOptions
                                        image={'about'}
                                        label={'About Us'}
                                        handleOptions={this.handleAbout}
                                    />

                                    {/* Contact Us */}
                                    <SettingOptions
                                        image={'contactUs'}
                                        label={'Contact Us'}
                                        enableRightArrow={false}
                                        handleOptions={this.handleContactUs}
                                    />

                                    {/* Terms & Conditions — opens the in-app ENConnect page */}
                                    <SettingOptions
                                        image={'about'}
                                        label={'Terms & conditions'}
                                        handleOptions={() => openLink('/terms')}
                                    />

                                    {/* Privacy Policy — opens the in-app ENConnect page */}
                                    <SettingOptions
                                        image={'policy'}
                                        label={'Privacy Policy'}
                                        handleOptions={() => openLink('/privacyPolicy')}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                {!parentAboutStatus &&
                    <Fragment>
                        {activeTab === 'about' && <AboutDetails backToAbout={this.backToAbout} />}
                        {activeTab === 'policy' && <PrivacyPolicy backToAbout={this.backToAbout} />}
                    </Fragment>}
                {activeTab === 'contactUs' && <ContactUs handlePopupClose={this.handlePopupClose} />}
            </Fragment>
        );
    }
}

About.propTypes = {
    handleBackToSetting: PropTypes.func,
};